/* eslint-disable prettier/prettier */
import React, { useEffect, useRef, useState } from 'react';
import { Col, Tabs, Row } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useInViewport, useAsyncEffect } from 'ahooks';
import { useNavigate } from 'react-router-dom';
import { request } from '@/config/request';
import ToAgentProcurement from '@/components/ToAgentProcurement';
import { isLogin } from '@/config/request/login';
import { ProductVO } from '@/service/market';
import GoodsItem from '@/common/CKBLayout/modules/GoodsItem';
import { PRODUCT_STATUS_TYPE } from '@/const/enum';
import styles from './index.module.scss';
const RecommendPlate: React.FC = () => {
  const containerRef = useRef(null);
  const loadMoreRef = useRef(null);
  const login = isLogin();
  const [classifyList, setClassifyList] = useState<any>([]);
  const [goodsParams, setGoodsParams] = useState({
    pageNum: 1,
    pageSize: 20,
    productCategoryFrontendId: 0
  });
  const [recommendList, setRecommendList] = useState<ProductVO[]>([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [goodsList, setGoodsList] = useState<any[]>([]);
  const [loadMoreInViewport] = useInViewport(loadMoreRef);
  const [agentProductCode, setAgentProductCode] = useState('');
  const toAgentProcurement = productCode => {
    setShowModal(true);
    setAgentProductCode(productCode);
  };
  const handleShowModalChange = newShowModal => {
    setShowModal(newShowModal);
  };
  useEffect(() => {
    request.goods.productCategoryFrontend.tree({}).then(res => {
      const newCateList = res.data || [];
      newCateList.unshift({
        cateNameJp: window._$m.t('全て'),
        productCategoryFrontendId: 0
      });
      setClassifyList(newCateList);
    });
  }, []);
  useAsyncEffect(async () => {
    setLoading(true);
    if (loading) return;
    const {
      productCategoryFrontendId,
      pageNum,
      pageSize
    } = goodsParams;
    let goodsList: any[] = [];
    // 第一页的时候先显示为你推荐
    if (!productCategoryFrontendId && pageNum === 1) {
      const res = await request.market.recommend.show({
        bizScene: '1',
        sourceChannel: '1'
      });
      if (res.success) {
        goodsList = (res.data || []).map(item => ({
          ...item,
          showGoBackPrice: true
        }));
        setRecommendList(res.data || []);
      }
      const res4 = await request.market.activity.areaList({
        bizScene: '1',
        sourceChannel: '1'
      });
      if (res4?.data?.length && res4.data.length > 3) {
        const res1 = await request.market.activity.areaMoreProduct({
          needTopProduct: false,
          areaId: res4.data[1].id,
          pageNum: 1,
          pageSize: 100
        });
        res1.data?.records?.length && (goodsList = goodsList.concat(res1.data?.records));
        const res2 = await request.market.activity.areaMoreProduct({
          needTopProduct: false,
          areaId: res4.data[2].id,
          pageNum: 1,
          pageSize: 100
        });
        res2.data?.records?.length && (goodsList = goodsList.concat(res2.data?.records));
      }
    }
    const goodsRes = await request.goods.product.searchKeyword({
      pageNum,
      pageSize,
      productCategoryFrontendId: goodsParams.productCategoryFrontendId === 0 ? undefined : goodsParams.productCategoryFrontendId
    });
    if (!goodsRes.success) return;
    const {
      data
    } = goodsRes;
    goodsList = goodsList.concat(data?.records?.filter(i => i.status && [PRODUCT_STATUS_TYPE.PENDING_OFFLINE, PRODUCT_STATUS_TYPE.SELLING].includes(i.status) || i.productPurchaseType === 1) || []);
    // 当前是第一页，数据替换，不是第一页数据累加
    if (pageNum === 1) {
      setGoodsList(goodsList);
    } else {
      setGoodsList(state => {
        return goodsParams.productCategoryFrontendId === 0 ? state.concat(goodsList) : state.concat(goodsList).filter(item => !item.showGoBackPrice);
      });
    }
    setLoading(false);
  }, [goodsParams]);
  useAsyncEffect(async () => {
    if (loadMoreInViewport) {
      setGoodsParams(state => ({
        ...state,
        pageNum: state.pageNum + 1
      }));
    }
  }, [loadMoreInViewport]);
  const onChange = (key: string) => {
    setGoodsParams(state => ({
      ...state,
      pageNum: 1,
      pageSize: 20,
      productCategoryFrontendId: Number(key)
    }));
  };
  // 没有为你推荐商品，模块不显示
  if (!recommendList.length) {
    return null;
  }
  return <div className={styles.container}>
            <Row style={{
      width: '100%',
      marginLeft: 0,
      marginRight: 0
    }}>
                <Col span={24} style={{
        width: '100%',
        paddingLeft: 0
      }}>
                    <div ref={containerRef} className={styles.plate}>
                        <div className={styles.wrap}>
                            <div className={styles.title}>
                                <div className={styles.name}>
                                    {window._$m.t('为你推荐')}
                                </div>
                                <span className={styles.desc}>
                                    {window._$m.t('根据您的浏览，实时为您推荐爆款产品')}
                                </span>
                            </div>
                        </div>
                        <Tabs className={styles.noLine} defaultActiveKey="1" tabBarStyle={{
            borderBottom: 'none'
          }} items={classifyList.map(item => ({
            key: String(item.productCategoryFrontendId),
            label: item.cateNameJp
          }))} onChange={onChange} />
                        <div className={styles.list}>
                            {goodsList.map((product, index) => <div key={index} style={{
              marginBottom: 16
            }}>
                                    <GoodsItem product={product} showGoBackPrice={product.showGoBackPrice} isLogin={login} showTags={true} openToAgentModal={() => toAgentProcurement(product.productCode)} />
                                </div>)}
                        </div>
                        <div ref={loadMoreRef} />
                        {loading && <div className={styles.loading}>
                                <LoadingOutlined className={styles.icon} />
                                {window._$m.t('内容加载中，请稍后...')}
                            </div>}
                    </div>
                </Col>
    </Row>
    <ToAgentProcurement showModal={showModal} onShowModalChange={handleShowModalChange} productCode={agentProductCode} />
        </div>;
};
export default RecommendPlate;